import React, {useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";

import {notification} from "antd";
import {RoundedCheck,} from "../../../../assets/icons/defaultIcons";
import {useJournal} from "../../../providers/JournalContext";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {maxLength, PasswordValidation, Required,} from "../../../utils/patterns";
import PasswordInput from "../../../components/common/password-field/PasswordInput";
import {UserAuthService} from "../../../services/user-auth-api.service";
import ForumLoaderSkeleton from "../../skeletons/forum/ForumLoaderSkeleton";

export default function ValidateForumPassword({
  close,
  getListing,
  setGetListing,
}) {
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const { setUpdateJournalProfile, updateJournalProfile } = useJournal();
  const {
    validateJournalPass,
    setValidateJournalPass,
    firstTimePassword,
    userEmail,
    setVerifyJournalOtp,
    verifyJournalOtp,
    setFirstTimeForumPassword,
  } = useJournal();
  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isValid },
    control,
    clearErrors,
  } = useForm({
    mode: "onChange",
  });
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setLoader(true);
    if (data) {
      let payload = {
        password: data.password,
      };
      const response = await UserAuthService.ValidateJournalPassword(payload);
      if (response?.data?.data?.status) {
        notification.success({
          message: "Success",
          description: "Forum password validated successful",
          placement: "topRight",
          icon: <RoundedCheck />,
          duration: 2,
        });
        setFirstTimeForumPassword(true);
        navigate("/forum");
      } else {
        // notification.error({
        //   message: "Failed",
        //   description: response.data?.data?.message,
        //   placement: "topRight",
        //   icon: <CloseRoundedCheck />,
        //   duration: 2,
        // });
      }
    }
    setLoader(false);
  };

  //   useEffect(() => {
  //     if (firstTimePassword === true) {
  //       navigate("/journals/set-journal-password");
  //     } else if (validateJournalPass === true) {
  //       navigate("/journals/validate-password");
  //     }
  //   }, [firstTimePassword, validateJournalPass]);

  const ResetPasswordFun = async () => {
    setLoader(true);
    const result = await UserAuthService.ForgetPasswordApi(userEmail);
    if (result?.data?.data?.status) {
      notification.success({
        message: "Success",
        description: `${result?.data?.data?.message}`,
        placement: "topRight",
        icon: <RoundedCheck />,
        duration: 2,
      });
      setVerifyJournalOtp(false);
      navigate("/journals/journal-otp-screen", { state: { email: userEmail } });
    }
    setLoader(false);
  };


  async function GetProfileData() {
    setLoading(true)
    const response = await UserAuthService.getProfileData();
    if (response?.data?.data?.status) {
      if (!response.data?.data?.data?.user?.forumId){
        navigate('/')
      }
      setLoading(false)
    }
  }

  useEffect(() => {
    GetProfileData();
  }, []);

  if (loading) {
    return (
        <ForumLoaderSkeleton/>
    );
  }

  return (
    <div className={"align-content-center h-100"}>
      <div className={"validate-journals"}>
        <h3>Enter Your App Password</h3>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className={"dfields"}>
            <Controller
              name="password"
              defaultValue={""}
              control={control}
              rules={{
                required: Required,
                pattern: PasswordValidation,
                maxLength: maxLength(100),
              }}
              render={({ field: { name, ...field } }) => (
                <PasswordInput
                  placeholder={"Your password here"}
                  label={"Password"}
                  field={field}
                  errors={errors.password}
                  className={"required"}
                />
              )}
            />
          </div>
          <div className={"mt-30 mb-30"}>
            <ThemeButton
              text={"Proceed"}
              type={"submit"}
              className={"btn-light-lg"}
              loader={loader}
            />
          </div>
          {/*<p className={'forget-pass'} onClick={()=>{ ResetPasswordFun()}}>Forgot Password?</p>*/}
        </Form>
      </div>
    </div>
  );
}
